import { useEffect, useState } from 'react';
import { Box, Paper, Container, Typography } from '@mui/material';
import { useTranslator } from 'translation/useTranslator';
import { Button } from '@nps.today/component-library';

type ErrorFallbackProps = {
  error: Error;
};
const ErrorFallback = ({ error }: ErrorFallbackProps) => {
  const translator = useTranslator();
  const [isChunkError, setIsChunkError] = useState(false);
  // Handle failed lazy loading of a JS/CSS chunk.
  useEffect(() => {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (error?.message && chunkFailedMessage.test(error.message)) {
      setIsChunkError(true);
    }
  }, [error]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'background.neutral'
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ padding: '20px', textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            {translator.oopsSomethingWentWrong()}
          </Typography>
          {isChunkError && (
            <Typography variant="body1" color="textSecondary">
              {translator.itLooksLikeANewVersionOfTheAppIsAvailable()}
            </Typography>
          )}
          {error?.message && (
            <Typography variant="body2" color="error" sx={{ marginTop: '10px' }}>
              {translator.errorWithMessage(error.message)}
            </Typography>
          )}
          <Button
            dataTestId="refresh-page"
            variant="contained"
            color="primary"
            sx={{ marginTop: '20px' }}
            onClick={() => globalThis.location.reload()}
          >
            {translator.clickHereToRefresh()}
          </Button>
        </Paper>
      </Container>
    </Box>
  );
};

export default ErrorFallback;
